<template>
  <div style="height: 40px ; text-align: left">
    <v-select
      :items="items"
      @change="setModelData"
      background-color="#ffffff"
      outlined
      :value="model"
      style="border-radius: 30px; text-align: left!important;"
      :disabled="disable"
      :multiple="multiple"
      dense
    >
    <template v-if="multiple" v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.text }}</span>
      </v-chip>
      <span
              v-if="index === 1"
              class="grey--text caption"
      >
            (+{{ model.length - 1 }} others)
          </span>
    </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "selectOption",
  props: {
    items: Array,
    model: [],
    disable : {
      type : Boolean,
      default : false,
    },
    multiple: {
      type : Boolean,
      default : false,
    }
  },
  methods: {
    setModelData(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped></style>
